export default "__VITE_ASSET__CxSJlMhO__"